module.exports = __webpack_public_path__ + "static/media/golfer-6-b.91e8971a.png";